import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  handleGetAccount,
  handleGetAccounts,
  handleGetAccountsSelection,
  handleGetSelectAccounts,
  handleGetSelectSalePersons,
} from './accountThunk';
import { IAccountList, ISelectAccount } from '~/utils/interface/account';
import { SortField } from '~/utils/types/common';
import { DEFAULT_PAGE, ROWS_PER_PAGE } from '~/utils/constants/common';

export interface AccountState {
  selectAccounts: Array<ISelectAccount>;
  selectionAccounts: Array<ISelectAccount>;
  filter: IAccountFilter;
  currentPage: number;
  totalPages: number;
  needRefreshData: boolean;
  accounts: Array<IAccountList>;
  selectedIds: Array<string>;
  accountId: string;
  openAlertDelete: boolean;
  menuSelectedId: string | undefined;
  selectSalePersons: Array<ISelectAccount>;
}

interface IAccountFilter {
  page?: number;
  limit?: number;
  search?: string;
  searchFields?: Array<string>;
  sort?: Array<SortField>;
}

const initialState: AccountState = {
  selectAccounts: [],
  selectSalePersons: [],
  selectionAccounts: [],
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  needRefreshData: false,
  filter: {
    page: 1,
    limit: ROWS_PER_PAGE,
    search: '',
    searchFields: [],
    sort: [],
  },
  selectedIds: [],
  accounts: [],
  accountId: '',
  openAlertDelete: false,
  menuSelectedId: undefined,
};

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<IAccountFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
    changeAccountId(state, action: PayloadAction<string>) {
      state.accountId = action.payload;
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
    },
    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
  },

  extraReducers(builder) {
    builder
      .addCase(handleGetSelectAccounts.pending, (_state, _action) => {})
      .addCase(handleGetSelectAccounts.fulfilled, (state, action) => {
        state.selectAccounts = [...action.payload.responses];
      })

      .addCase(handleGetSelectSalePersons.pending, (_state, _action) => {})
      .addCase(handleGetSelectSalePersons.fulfilled, (state, action) => {
        state.selectSalePersons = [...action.payload.responses];
      })
      .addCase(handleGetAccounts.fulfilled, (state, action) => {
        state.accounts = [...action.payload.responses];
        state.currentPage = action.payload.pagination.page;
        state.totalPages = action.payload.pagination.totalPages;
        state.needRefreshData = false;
      })

      .addCase(handleGetAccount.fulfilled, (state, action) => {
        state.needRefreshData = false;
      })
      .addCase(handleGetAccountsSelection.fulfilled, (state, action) => {
        state.selectionAccounts = [...action.payload.responses];
      })
      .addCase(handleGetSelectAccounts.rejected, (_state, _action) => {});
  },
});

export const accountActions = accountSlice.actions;

const accountReducer = accountSlice.reducer;
export default accountReducer;
